module.exports = __webpack_public_path__ + "media/images/help/faq-dashboard-status-f2e7d40b0225edf517ee76494c69a1b8.jpg";